// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `

p.h6.success, .card-default .card-body p.success{
    font-size: 14px;
    color: #33AC2E !important;
    position: absolute;
    top: 50px;
    width: 27%;
    text-align: center;
    transform: translate(125%, -0%) !important;
}

p.h6.error, .card-default .card-body p.error{
    font-size: 12px;
    color: #E84A50 !important;
    position: absolute;
    top: 50px;
    width: 25%;
    text-align: center;
    transform: translate(125%, -0%) ;
}

`, "",{"version":3,"sources":["webpack://./src/Components/Alert/Alert.css"],"names":[],"mappings":";;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,kBAAkB;IAClB,0CAA0C;AAC9C;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,kBAAkB;IAClB,gCAAgC;AACpC","sourcesContent":["\n\np.h6.success, .card-default .card-body p.success{\n    font-size: 14px;\n    color: #33AC2E !important;\n    position: absolute;\n    top: 50px;\n    width: 27%;\n    text-align: center;\n    transform: translate(125%, -0%) !important;\n}\n\np.h6.error, .card-default .card-body p.error{\n    font-size: 12px;\n    color: #E84A50 !important;\n    position: absolute;\n    top: 50px;\n    width: 25%;\n    text-align: center;\n    transform: translate(125%, -0%) ;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
